import React, { useState, useEffect } from 'react';
import { CSSTransition } from 'react-transition-group';
import { Route, withRouter, Link } from 'react-router-dom';
import classNames from 'classnames';
import striptags from 'striptags';
import { Helmet } from 'react-helmet';
import { find, isUndefined } from 'lodash';
import { connect } from 'react-redux';
import { getPreviousAndNext, getPhotoLabel } from '../../helpers.js';



const JobOverview = props => {
  const [ hovered, setHovered ] = useState(false);
  const [ selected, setSelected ] = useState(false);

  useEffect(() => {
    console.log(props.visible);
    if(props.visible){
      document.body.classList.add('job-overview-active');
    }else{
      document.body.classList.remove('job-overview-active');
    }
  }, [props.visible]);

  const _handleClick = e => {
    setSelected(true);

    setTimeout(() => {
      props.onPhotoSelect();

      setTimeout(() => {
        setSelected(false);
      }, 500);
    }, 800);
  }
  return (
    <div className={classNames('job__overview', {
      'job__overview--visible': props.visible,
      'job__overview--selected': selected,
      'job__overview--hovered': hovered
    })}>
      <div className="close" onClick={() => props.onPhotoSelect()}>close</div>
      <div className="inner">
        {props.photos && props.photos.map((photo, i) => (
          <Link
            key={i}
            className="overview-item"
            to={`${props.linkBase}${i}`}
            onClick={e => _handleClick(e)}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            >
            <img src={photo.sizes.large} className='overview-item__image' />
          </Link>
        ))}
      </div>
    </div>
  )
}

class Job extends React.Component {
  constructor(props){
    super(props);

    this.state = {
      overviewVisible: false
    }
  }
  componentDidMount(){
    if(this.props.label){
      this._setHeaderLabels();
    }
  }
  componentDidUpdate(prevProps){
    if(prevProps.labelString){
      // has already had label
      if(prevProps.labelString !== this.props.labelString){
        // has different labels
        console.log('has different labels', prevProps.labelString, this.props.labelString);
        this._setHeaderLabels();
      }else{
        // has same labels, but different photo or job
        if(prevProps.photoId !== this.props.photoId || prevProps.jobId !== this.props.jobId){
          console.log('has same labels, but different photo or job');
          this._setHeaderLabels();
        }
      }
    }else{
      if(this.props.labelString){
        console.log('!prevProps.label && this.props.label');
        this._setHeaderLabels();
      }
    }
    if(this.props.photographer){
      document.body.style.background = this.props.photographer.acf.secondary_color;
    }
  }

  _setHeaderLabels = () => {
    this.props.onPhotoMount(this.props.label, this.props.photoId + 1, this.props.photosInJob);
    this._attachKeyHandlers();
  }

  _handlePrevClick = () => {
    const { photographer, nextPhoto, previousPhoto } = this.props;
    this.props.history.push(`/photographers/${photographer.slug}/${previousPhoto.job}/${previousPhoto.photo}`);
  }

  _handleNextClick = () => {
    const { photographer, nextPhoto, previousPhoto } = this.props;
    this.props.history.push(`/photographers/${photographer.slug}/${nextPhoto.job}/${nextPhoto.photo}`);
  }

  _attachKeyHandlers = () => {
    document.addEventListener('keydown', this._handleKeyPress);
  }

  _detachEvents = () => {
    document.removeEventListener('keydown', this._handleKeyPress);
  }

  _handleKeyPress = e => {
    const { photographer, nextPhoto, previousPhoto } = this.props;

    switch (e.code) {
      case 'ArrowUp':
        this.setState({overviewVisible: true});
        break;
      case 'ArrowDown':
        this.setState({overviewVisible: false});
        break;
      case 'ArrowLeft':
        this._handlePrevClick();
        break;
      case 'ArrowRight':
        this._handleNextClick();
        break;
      case 'Escape':
        if(this.state.overviewVisible){
          this.setState({overviewVisible: false});
        }else{
          this.props.history.push(`/photographers/${photographer.slug}`, { fromDetailView: true });
        }
        break;
      default:

    }
  }

  componentWillUnmount(){
    document.removeEventListener('keydown', this._handleKeyPress);
    this.props.onUnmount();
  }

  _toggleOverview(){
    this.setState({overviewVisible: !this.state.overviewVisible});
  }

  render () {
    const { photographer, photo, nextPhoto, previousPhoto, title, client } = this.props;

    if(!photographer){
      return false;
    }


    return <div className={classNames('page page--job')}>
        <Helmet>
          <meta name='description' content={`${title} for ${client} by ${photographer.title.rendered} with AKKURAT Studios. ${striptags(photographer.content.rendered)}`} />
          <meta name='og:description' content={`${title} by ${photographer.title.rendered} for ${client} with AKKURAT Studios. ${striptags(photographer.content.rendered)}`} />
          <meta property="og:image" content={photo.url} />
          <meta property="og:image:height" content={photo.height} />
          <meta property="og:image:width" content={photo.width} />
          <meta property="og:image:type" content={`${photo.type}/${photo.subtype}`} />
        </Helmet>
        <Link className="navigation navigation--prev" to={`/photographers/${photographer.slug}/${previousPhoto.job}/${previousPhoto.photo}`}>Previous</Link>

        <div className="photo">
          <div className="photo__navigation photo__navigation--prev" onClick={this._handlePrevClick} />
          <img src={photo.sizes.fullscreen ? photo.sizes.fullscreen : photo.url} />
          <div className="photo__navigation photo__navigation--next" onClick={this._handleNextClick} />
        </div>

        <Link className="navigation navigation--next" to={`/photographers/${photographer.slug}/${nextPhoto.job}/${nextPhoto.photo}`}>Next</Link>



        <div className="job__footer">
          <Link to={{
            pathname: `/photographers/${photographer.slug}`,
            state: {
              fromDetailView: true
            }
          }}>Artist Page</Link>


          <div onClick={() => this._toggleOverview()}>
            View All
          </div>
        </div>

        <JobOverview
          photos={this.props.photos}
          visible={this.state.overviewVisible}
          linkBase={`/photographers/${photographer.slug}/${this.props.jobId}/`}
          onPhotoSelect={() => this.setState({overviewVisible: false})}
          />
      </div>;
  }
}


const mapStateToProps = (state, ownProps) => {

  const photographers = state.photographers.photographers;
  const photographer = find(photographers, { 'slug': ownProps.match.params.slug });

  if(!photographer){
    return {};
  }

  const jobId = parseInt(ownProps.match.params.job);
  const jobs = photographer.acf.jobs;
  const job = jobs[jobId];
  const photoId = parseInt(ownProps.match.params.photo) || 0;
  const photos = job.photos;
  const photo = photos[photoId];
  const { title, client } = job;

  let nextPhoto;
  let previousPhoto;

  const previousAndNextPhotoId =  getPreviousAndNext(job.photos.length, photoId);
  const previousAndNextJobId =  getPreviousAndNext(jobs.length, jobId);

  if(photoId == 0 && photoId == job.photos.length - 1){
    // is only photo in job
    previousPhoto = {
      job: previousAndNextJobId.previous,
      photo: jobs[previousAndNextJobId.previous].photos.length - 1
    };
    nextPhoto = {
      job: previousAndNextJobId.next,
      photo: 0
    };
  }else if(photoId == 0){
    // first photo in job
    previousPhoto = {
      job: previousAndNextJobId.previous,
      photo: jobs[previousAndNextJobId.previous].photos.length - 1
    };
    nextPhoto = {
      job: jobId,
      photo: previousAndNextPhotoId.next
    };
  }else if(photoId == job.photos.length - 1){
    // last photo in job
    previousPhoto = {
      job: jobId,
      photo: previousAndNextPhotoId.previous
    },
    nextPhoto = {
      job: previousAndNextJobId.next,
      photo: 0
    };
  }else{
    previousPhoto = {
      job: jobId,
      photo: previousAndNextPhotoId.previous
    };
    nextPhoto = {
      job: jobId,
      photo: previousAndNextPhotoId.next
    };
  }

  return {
    photographer,
    photosInJob: job.photos.length,
    jobId,
    photoId,
    photos,
    photo,
    title: job.title,
    client: job.client,
    previousPhoto,
    nextPhoto,
    label: getPhotoLabel(photographer, job.title, !job.hide_phrase && job.client),
    labelString: photographer + job.title + job.client
  }
}

export default withRouter(connect(mapStateToProps, null)(Job));
